export const WS_URL = process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8099/ws';